import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinGame from '@mixins/game'
import MixinStock from '@mixins/stock'

interface MinusObject {
  title: string,
  id: string,
  amountToRemove: number,
}

interface PlusObject {
  title: string,
  id: string,
  amountToAdd: number
}

@Component
export default class BoardBackground extends mixins(MixinGame, MixinStock) {
  get strokeStyle(): object {
    return {
      'stroke-width': this.lineWidth,
    }
  }

  @Prop(Number) public lineWidth: number

  private canBreathe = false

  @Watch('turnID', { immediate: true })
  public onTurnChange() {
    this.canBreathe = true
  }

  public doConversion(minus: MinusObject[], plus: PlusObject[]) {
    if (!this.canBreathe) {
      this.$flits.info('Je kan maar 1x per ronde ademhalen. Wacht tot de volgende ronde.')
      return
    }

    const enzymes = this.stockEnzymes
      .toArray()
      .filter((enzyme: any) => {
        return minus.find((item) => {
          return enzyme.id === item.id && enzyme.quantity >= item.amountToRemove
        })
      })

    if (enzymes.length !== minus.length) {
      this.$flits.info('Je hebt niet de benodigde input om adem te halen')
      return
    }

    minus.forEach((enzyme: MinusObject) => {
      this.storeUpdateTeamEnzyme({
        team: this.activeTeam,
        enzyme: this.$enzymes.find(enzyme.id),
        quantity: -enzyme.amountToRemove,
      })
    })

    plus.forEach((enzyme: PlusObject) => {
      this.storeUpdateTeamEnzyme({
        team: this.activeTeam,
        enzyme: this.$enzymes.find(enzyme.id),
        quantity: +enzyme.amountToAdd,
      })
    })

    this.breathe()
    this.canBreathe = false
  }

  public interconversionAddAdp() {
    const minus = [{
      title: 'AMP',
      id: 'r6q013nv',
      amountToRemove: 1,
    }, {
      title: 'ATP',
      id: '5mqgoz7y',
      amountToRemove: 1,
    }]

    const plus = [{
      title: 'ADP',
      id: 'dkzn8zn4',
      amountToAdd: 2,
    }]

    this.doConversion(minus, plus)
  }

  public interconversionRemoveAdp() {
    const minus = [{
      title: 'ADP',
      id: 'dkzn8zn4',
      amountToRemove: 2,
    }]

    const plus = [{
      title: 'AMP',
      id: 'r6q013nv',
      amountToAdd: 1,
    }, {
      title: 'ATP',
      id: '5mqgoz7y',
      amountToAdd: 1,
    }]

    this.doConversion(minus, plus)
  }

  public AtpEfficiencyOne() {
    const minus = [{
      title: 'NADH',
      id: '4x3egqor',
      amountToRemove: 1,
    }, {
      title: 'ADP',
      id: 'dkzn8zn4',
      amountToRemove: 3,
    }]

    const plus = [{
      title: 'NAD⁺',
      id: 'dgz17zre',
      amountToAdd: 1,
    }, {
      title: 'ATP',
      id: '5mqgoz7y',
      amountToAdd: 3,
    }]

    this.doConversion(minus, plus)
  }

  public AtpEfficiencyTwo() {
    const minus = [{
      title: 'FADH₂',
      id: '12zxrzmn',
      amountToRemove: 1,
    }, {
      title: 'ADP',
      id: 'dkzn8zn4',
      amountToRemove: 2,
    }]

    const plus = [{
      title: 'FAD',
      id: 'myqkwq9l',
      amountToAdd: 1,
    }, {
      title: 'ATP',
      id: '5mqgoz7y',
      amountToAdd: 2,
    }]

    this.doConversion(minus, plus)
  }
}
